import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Btn, H4, P} from '../../../../AbstractElements';
import {Form, FormGroup} from 'reactstrap';
import {useNavigate} from 'react-router-dom';
import axiosConfig from '../../../../Config/axios';
import {useForm} from "react-hook-form";
import TextInput from "../../../../CommonElements/Input/TextInput";
import Loader from "../../../../Layout/Loader";
import {ToastContainer, toast} from "react-toastify";
import {getAuthenticationRoute} from "../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

const TwoFactorVerification = () => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [email, setEmail] = useState<string>('');
    const [tempToken, setTempToken] = useState<string>('');
    const [resendTimer, setResendTimer] = useState(0);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        setError,
        formState: {errors},
    } = useForm();

    useEffect(() => {
        // Get email and temp token from localStorage
        const storedEmail = localStorage.getItem("2fa_email");
        const storedTempToken = localStorage.getItem("2fa_temp_token");
        if (!storedEmail || !storedTempToken) {
            navigate(`${process.env.PUBLIC_URL}/login`);
            return;
        }
        setEmail(storedEmail);
        setTempToken(storedTempToken);
    }, [navigate]);

    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer(prev => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [resendTimer]);

    const onSubmit = (data) => {
        setLoaderVisibility(true);
        const payload = {
            email: email,
            otp: data.otp,
            two_factor_temp_token: tempToken,
        };

        axiosConfig
            .post(`${getAuthenticationRoute('verify-login-email-otp')}`, payload)
            .then(response => {
                if (response?.data?.data?.user && response?.data?.data?.token) {
                    localStorage.removeItem("2fa_email");
                    localStorage.removeItem("2fa_temp_token");
                    localStorage.setItem("authenticated_user", JSON.stringify(response.data.data.user));
                    localStorage.setItem("authenticated_token", response.data.data.token);
                    document.location.href = `${process.env.PUBLIC_URL}/`;
                }
                setLoaderVisibility(false);
            })
            .catch(exception => {
                setLoaderVisibility(false);
                errorHandler(exception, setError);
            });
    };

    const handleResendOtp = () => {
        if (resendTimer > 0) return;

        setLoaderVisibility(true);
        axiosConfig
            .post(`${getAuthenticationRoute('resend-login-email-otp')}`, {
                email,
                two_factor_temp_token: tempToken,
            })
            .then(response => {
                toast.success('OTP resent to your email', {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000,
                });
                setResendTimer(60); // 60 seconds cooldown
                setLoaderVisibility(false);
            })
            .catch(exception => {
                setLoaderVisibility(false);
                errorHandler(exception);
            });
    };

    const handleBackToLogin = () => {
        localStorage.removeItem("2fa_email");
        localStorage.removeItem("2fa_temp_token");
        navigate(`${process.env.PUBLIC_URL}/login`);
    };

    return (
        <Fragment>
            <div className='login-card'>
                <div className='login-main'>
                    <Loader visibility={loaderVisibility}/>
                    <Form onSubmit={handleSubmit(onSubmit)}
                          className='theme-form login-form'>
                        <H4>Two-Factor Authentication</H4>
                        <P>Enter the OTP sent to your email</P>
                        <p className='text-muted mb-3'>
                            <small>Email: {email}</small>
                        </p>
                        <FormGroup className='text-end mb-3'>
                            <button
                                type='button'
                                className='btn-link text-muted'
                                onClick={handleBackToLogin}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                    fontSize: '0.875rem',
                                }}
                            >
                                ← Back to Login
                            </button>
                        </FormGroup>
                        <TextInput
                            name={'otp'}
                            type={'text'}
                            label={'One-Time Password'}
                            register={register}
                            errors={errors}
                            placeholder={'000000'}
                            options={{required: 'OTP is required'}}
                        />
                        <FormGroup>
                            <Btn attrBtn={{className: 'd-block w-100 mt-2', color: 'primary', type: 'submit',}}>
                                Verify OTP
                            </Btn>
                        </FormGroup>
                        <FormGroup className='text-center'>
                            <p className='text-muted'>
                                Didn't receive the OTP?{' '}
                                <button
                                    type='button'
                                    className='btn-link text-primary'
                                    onClick={handleResendOtp}
                                    disabled={resendTimer > 0}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: resendTimer > 0 ? 'not-allowed' : 'pointer',
                                        opacity: resendTimer > 0 ? 0.6 : 1,
                                        color: resendTimer > 0 ? '#999' : '#007bff',
                                    }}
                                >
                                    {resendTimer > 0 ? `Resend in ${resendTimer}s` : 'Resend OTP'}
                                </button>
                            </p>
                        </FormGroup>
                    </Form>
                </div>
                <ToastContainer/>
            </div>
        </Fragment>
    );
};

export default TwoFactorVerification;









